
import './index.less'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: 'contBox',
directives: {
TransferDom
},
props: {
data: Array,
strategyId: String,
replace: Boolean
},
data () {
return {
catalogShow: false,
handleRight: 0
}
},
updated () {
if (document.documentElement.clientWidth > 640) {
this.handleRight = (document.documentElement.clientWidth - 640) / 2
}
},
methods: {
showCatalog: function () {
this.catalogShow = true
},
linkTo: function (val1, val2) {
this.$emit("on-status-change", val1, val2)
this.catalogShow = false
},
closePopup: function () {
this.catalogShow = false
}
}
}
